var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 640,
    height: 644,
    viewBox: "0 0 640 644",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M509.865 308.117C507.592 308.117 506.682 308.117 504.181 308.117C477.123 308.802 451.884 300.814 434.831 276.848C414.821 248.773 387.536 242.154 356.84 244.208C324.552 246.263 292.265 248.773 259.977 251.969C242.014 253.566 224.279 256.077 206.543 259.501C206.089 259.501 205.861 259.501 205.406 259.729C197.903 262.468 198.358 274.565 205.861 276.848C206.316 276.848 206.543 276.848 206.998 277.076C217.685 278.674 228.599 278.902 239.286 278.674C269.982 278.674 300.45 277.761 331.146 277.304C347.29 277.304 357.522 283.239 358.204 292.825C358.659 302.411 348.882 309.03 332.283 309.487C299.314 310.4 266.571 310.628 233.601 311.998C222.46 312.454 211.318 314.965 200.404 317.247C197.676 317.932 193.355 321.127 193.355 324.551C193.355 330.714 197.448 332.54 200.632 333.453C208.362 335.735 216.548 337.333 224.506 337.561C259.977 338.702 295.675 339.387 331.146 340.528C337.286 340.528 343.88 341.898 349.337 344.637C360.478 350.115 360.933 362.44 350.019 369.059C345.699 371.798 339.787 372.483 334.557 372.483C314.775 372.939 294.993 372.483 275.211 372.483V372.027C256.339 372.027 237.467 372.027 218.367 372.027C214.274 372.027 209.954 371.342 206.316 372.939C205.406 373.396 204.497 373.852 203.587 374.309C198.13 377.733 197.676 386.406 203.133 390.058C204.042 390.743 204.952 391.199 206.089 391.656C212.91 393.938 220.186 394.395 227.462 395.079C267.253 398.96 307.272 402.612 347.063 406.035C382.761 409.231 414.821 403.296 438.696 370.201C451.884 351.941 470.984 341.898 493.04 343.267C498.951 343.496 502.589 343.952 508.274 344.18C509.865 337.333 510.775 330.486 510.775 323.41C510.775 318.16 510.32 312.911 509.411 307.889L509.865 308.117Z",
    fill: "url(#paint0_linear_2758_13742)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0607 300.937C92.3435 302.308 123.802 288.829 147.511 265.527C152.982 260.273 156.857 255.018 162.556 249.992C166.66 246.337 170.535 242.682 174.638 239.255C213.164 205.901 280.87 189.681 328.742 193.108C371.827 196.078 383.453 197.905 424.031 213.44C426.083 214.354 428.362 215.268 430.414 216.41C446.371 225.091 471.447 240.626 481.478 251.82C510.657 284.489 540.292 307.106 583.834 303.907C588.393 303.679 592.952 303.222 597.283 302.765C611.417 301.623 625.779 300.252 639.913 298.881C634.898 218.237 602.755 148.788 543.256 90.7607C483.757 32.7337 402.83 0.0649414 319.851 0.0649414C231.401 0.0649414 155.945 31.363 93.4833 94.1875C36.2644 151.529 5.2613 219.608 0.246094 298.653C17.7993 299.567 35.3525 300.48 52.9057 301.166H59.0607V300.937Z",
    fill: "url(#paint1_linear_2758_13742)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M475.088 401.156C464.815 412.362 439.475 427.686 420.298 435.004C376.695 451.242 360.715 453.529 311.176 453.758C265.062 452.843 207.761 436.605 172.148 403.901C168.952 400.927 165.756 397.954 162.56 394.752C140.187 373.483 117.359 351.985 85.398 348.097C60.0579 344.895 33.8046 344.209 8.46444 346.954L0.246094 347.868C5.95333 427.457 38.3703 496.068 97.7256 553.472C157.081 611.105 237.667 643.352 320.308 643.352C408.884 643.352 484.676 612.02 547.227 549.126C602.702 493.552 633.749 427.686 639.913 351.528C618.454 350.155 597.223 348.783 575.763 347.411C535.128 344.895 502.711 370.967 475.088 401.156Z",
    fill: "url(#paint2_linear_2758_13742)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2758_13742",
    x1: -529.706,
    y1: -367.036,
    x2: 1616.1,
    y2: 1353.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F78167"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2324E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2758_13742",
    x1: -423.311,
    y1: -367.516,
    x2: 1579.3,
    y2: 1240.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F78167"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2324E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2758_13742",
    x1: -512.72,
    y1: -257.278,
    x2: 1492.45,
    y2: 1353.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F78167"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2324E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/Frame.9c055a5b9a196dbc5b52a6a33b4494c2.svg";
export { ForwardRef as ReactComponent };